import { render, staticRenderFns } from "./ElectionsGeneral.vue?vue&type=template&id=279f9024&scoped=true"
import script from "./ElectionsGeneral.vue?vue&type=script&lang=js"
export * from "./ElectionsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f9024",
  null
  
)

export default component.exports